<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="titlepage">
<div class="ipadfp"><span aria-label="i" epub:type="pagebreak" id="page_i" role="doc-pagebreak" title="i"><span aria-label="ii" epub:type="pagebreak" id="page_ii" role="doc-pagebreak" title="ii"><span aria-label="iii" epub:type="pagebreak" id="page_iii" role="doc-pagebreak" title="iii"><img alt="Revenge of the Red Club by Kim Harrington, Aladdin" class="imagefp" src="e9781534435742/images/title.jpg"/></span></span></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?52079860